const questions = [
    {
        id:1,
        question:"What is React?",
        options:["Library", "Freamework", "Language", "Database"],
        answer:"Library",
        category:"Frontend"
    },
    {
        id:2,
        question:"What is Javascript used for?",
        options:["Styling", "Structure", "Logic", "Database"],
        answer:"Logic",
        category:"Programming"
    },
    {
        id:3,
        question:"What is CSS?",
        options:["Structure", "Styling", "Logic", "Backend"],
        answer:"Styling",
        category:"Frontend"
    }
]

export default questions;